import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getVoucherMode,
  getParticularPage,
  getNext,
  getPrevious,
  createVoucherMode,
  updateVoucherMode,
  handleSearch,
} from "./thunk";

const initialState = {
  voucherModes: [],
  edit: false,
  voucherMode: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingVoucherMode: false,
  loadingNext: false,
  showCreateModal: false,
};

export const voucherModeSlice = createSlice({
  name: "voucherMode",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    voucherModeEditSuccess: (state, action) => {
      state.edit = true;
      state.voucherMode = state.voucherModes.find((voucherMode) => voucherMode.id === action.payload);
    },
    clearAllVoucherMode: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingVoucherMode = false;
      state.voucherMode = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createVoucherMode.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createVoucherMode.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createVoucherMode.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateVoucherMode.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateVoucherMode.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateVoucherMode.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getVoucherMode.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingVoucherMode = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getVoucherMode.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingVoucherMode = false;
        state.voucherModes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getVoucherMode.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingVoucherMode = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, voucherModeEditSuccess, clearAllVoucherMode } = voucherModeSlice.actions;

export default voucherModeSlice.reducer;
